// SCRUM-491 / SCRUM-422: the Users page lists soft-deleted athletes and
// accounts too; merge buttons and pickers only ever offer live ones.
export const isDeleted = (row) => !!row?.deletedAt;

export const liveAthletes = (user) => (user?.Attendees || []).filter((a) => !isDeleted(a));

export const canMergeAccount = (user) => user.role === 'PARENT' && !isDeleted(user);

export const mergeTargets = (users, source) => users.filter((u) => u.id !== source.id && canMergeAccount(u));
